import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [emailCopied, setEmailCopied] = useState(false);

  const handleEmailCopy = async () => {
    try {
      await navigator.clipboard.writeText('nxv200004@utdallas.edu');
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy email:', err);
      window.location.href = 'mailto:nxv200004@utdallas.edu';
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <h1>Neeraj's Portfolio</h1>
        </div>
        <nav className="nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/resume-access" className="nav-link">Resume</Link>
          <a href="mailto:nxv200004@utdallas.edu">
          <button onClick={handleEmailCopy} className="nav-link nav-button">
            {emailCopied ? 'Email Copied!' : 'Contact'}
          </button>
          </a>
          <a href="https://www.linkedin.com/in/-neeraj-reddy" target="_blank" rel="noopener noreferrer" className="nav-link">Linkedin</a>
          <a href="https://github.com/DarkFerrari" target="_blank" rel="noopener noreferrer" className="nav-link">GitHub</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
